import { useId } from "react";
import styles from "./JourneyCardCurve.module.css";

// The curve from the "JourneyCard-Curve-B" board, in the card's 768 × 460 box: from the lower left, behind the scores,
// up towards the QR code.
const CURVE = "M -30 390 C 150 350, 240 420, 360 370 S 540 230, 610 190 S 680 140, 700 128";

// --color-cta. Coral is much lighter than petrol, so it takes more coverage to read as a warm glow on the light cards.
const CORAL = "#F08A6C";

// Two out of focus layers, only hinting at the journey. On petrol a little less, so the glow shows without taking over.
const LAYERS = [
  { name: "wide", width: 110, blur: 18, opacity: 0.16, darkOpacity: 0.14 },
  { name: "narrow", width: 34, blur: 7, opacity: 0.14, darkOpacity: 0.12 },
];

type JourneyCardCurveProps = {
  /** The card is dark (petrol), with light text. */
  dark?: boolean;
};

/** The still, coral journey behind the content of the Journey Card. Fades out at both ends. */
const JourneyCardCurve = ({ dark = false }: JourneyCardCurveProps) => {
  const id = `card-curve-${useId().replace(/:/g, "")}`;

  return (
    <svg aria-hidden='true' className={styles.curve} data-testid='journey-card-curve' viewBox='0 0 768 460' preserveAspectRatio='none'>
      <defs>
        <linearGradient id={id} x1='0' y1='0' x2='1' y2='0'>
          <stop offset='0%' stopColor={CORAL} stopOpacity='0' />
          <stop offset='25%' stopColor={CORAL} />
          <stop offset='85%' stopColor={CORAL} />
          <stop offset='100%' stopColor={CORAL} stopOpacity='0' />
        </linearGradient>
      </defs>
      {LAYERS.map((layer) => (
        <path
          key={layer.name}
          d={CURVE}
          data-layer={layer.name}
          fill='none'
          stroke={`url(#${id})`}
          strokeWidth={layer.width}
          strokeLinecap='round'
          vectorEffect='non-scaling-stroke'
          opacity={dark ? layer.darkOpacity : layer.opacity}
          style={{ filter: `blur(${layer.blur}px)` }}
        />
      ))}
    </svg>
  );
};

export default JourneyCardCurve;
